import React, { useEffect } from 'react';
import { LanguageProvider } from './context/LanguageContext';
import { loadCookieConsent } from './utils/loadCookieConsent';
import Header from './components/Header';
import Hero from './components/Hero';
import Stats from './components/Stats';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Benefits from './components/Benefits';
import CTA from './components/CTA';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

function App() {
  useEffect(() => {
    loadCookieConsent();
  }, []);

  return (
    <LanguageProvider>
      <div className="min-h-screen bg-cream font-body text-ink antialiased">
        <Header />
        <Hero />
        <Stats />
        <Features />
        <HowItWorks />
        <Benefits />
        <CTA />
        <FAQ />
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
